import React, { useState } from 'react';

import Icon from '../../components/AppIcon';
import { storageService } from '../../services/storageService';

const ImageUpload = ({ onUpload, bucket = 'images', path = '', className = '' }) => {
	const [uploading, setUploading] = useState(false);
	const [uploadedUrl, setUploadedUrl] = useState('');

	const handleFileUpload = async (event) => {
		const file = event.target.files[0];
		if (!file) return;

		setUploading(true);
		try {
			const { data, error } = await storageService.uploadImage(file, bucket, path);

			if (error) {
				console.error('Upload error:', error);
				alert('Upload failed: ' + error.message);
				return;
			}

			setUploadedUrl(data);
			// Pass the file and path to the callback
			onUpload?.(file, path);
		} catch (err) {
			console.error('Upload error:', err);
			alert('Upload failed: ' + err.message);
		} finally {
			setUploading(false);
		}
	};

	return (
		<div className={`image-upload ${className}`}>
			<div className='upload-area border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-gray-400 transition-colors'>
				<input
					type='file'
					accept='image/*'
					onChange={handleFileUpload}
					disabled={uploading}
					className='hidden'
					id='image-upload'
				/>
				<label htmlFor='image-upload' className='cursor-pointer'>
					{uploading ? (
						<div className='flex flex-col items-center'>
							<div className='animate-spin rounded-full h-8 w-8 border-b-2 border-[#800020] mb-2'></div>
							<p className='text-gray-600'>Uploading...</p>
						</div>
					) : (
						<div className='flex flex-col items-center'>
							<Icon name='Upload' size={32} className='text-gray-400 mb-2' />
							<p className='text-gray-600 mb-1'>Click to upload image</p>
							<p className='text-sm text-gray-500'>PNG, JPG, GIF up to 10MB</p>
						</div>
					)}
				</label>
			</div>

			{uploadedUrl && (
				<div className='mt-4'>
					<p className='text-sm text-green-600 mb-2'>✅ Upload successful!</p>
					<div className='bg-gray-100 p-3 rounded'>
						<p className='text-xs text-gray-600 break-all'>{uploadedUrl}</p>
					</div>
					<div className='mt-2'>
						<img
							src={uploadedUrl}
							alt='Uploaded'
							className='max-w-full h-32 object-cover rounded'
						/>
					</div>
				</div>
			)}
		</div>
	);
};

export default ImageUpload;
